import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Loader from "../components/loader";
import "./OwnerLogin.css";

export default function OwnerLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  localStorage.removeItem("verificationRole");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/owner/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          credentials: "include"
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Admin login failed");
      } else {
        localStorage.setItem("adminLoggedIn", "true");
        navigate(`/Owner/dashboard/${process.env.REACT_APP_OWNER_PATH}/en-list/owner`, { replace: true });
      }
    } catch (err) {
      setError("Something went wrong");
    }

    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <div className="owner-auth-wrapper">
      <form className="owner-auth-card" onSubmit={handleSubmit}>
        <h2 className="owner-auth-title">Owner Login</h2>

        <div className="owner-auth-input">
          <FaEnvelope />
          <input
            name="email"
            type="email"
            placeholder="Owner Email"
            onChange={handleChange}
            required
          />
        </div>

        <div className="owner-auth-input">
          <FaLock />
          <input
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <span
            className="owner-auth-eye"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>

        {error && <p className="owner-auth-error">{error}</p>}

        <button className="owner-auth-btn">Login</button>

        {/* ✅ SIGN UP LINK */}
        <p className="owner-auth-footer">
          Don't have an Owner account?{" "}
          <br/>
          <span
            className="owner-auth-link"
            onClick={() => navigate("/Owner/signup")}
          >
            Click here to Sign Up
          </span>
        </p>
      </form>
    </div>
  );
}
